/**
 * Native replacements for two Vitals widgets: Favicon Cart Count and
 * Inactive Tab Message. Configured via Theme Settings → Storefront Extras.
 * Reads window.mtaStorefrontExtras, set in snippets/mta-storefront-extras.liquid.
 */
(function () {
  const config = window.mtaStorefrontExtras || {};

  /* ---------------- Favicon Cart Count ---------------- */
  const favicon = config.faviconCount;
  if (favicon && favicon.enabled) {
    let faviconLink = document.querySelector('link[rel="icon"]');
    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }
    const originalHref = faviconLink.href;
    let sourceImage = null;

    function drawBadge(count) {
      if (!sourceImage) return;

      const size = 64;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, size, size);
      ctx.drawImage(sourceImage, 0, 0, size, size);

      if (count > 0) {
        const badgeSize = size * 0.52;
        let bx;
        let by;
        switch (favicon.position) {
          case 'bottom_right':
            bx = size - badgeSize / 2;
            by = size - badgeSize / 2;
            break;
          case 'top_left':
            bx = badgeSize / 2;
            by = badgeSize / 2;
            break;
          case 'top_right':
            bx = size - badgeSize / 2;
            by = badgeSize / 2;
            break;
          default:
            bx = badgeSize / 2;
            by = size - badgeSize / 2;
        }

        ctx.fillStyle = favicon.bgColor || '#ff0101';
        if (favicon.shape === 'square') {
          const half = badgeSize / 2;
          ctx.fillRect(bx - half, by - half, badgeSize, badgeSize);
        } else {
          ctx.beginPath();
          ctx.arc(bx, by, badgeSize / 2, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.fillStyle = favicon.textColor || '#ffffff';
        ctx.font = `bold ${Math.round(badgeSize * 0.62)}px -apple-system, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(count > 99 ? '99+' : String(count), bx, by + 1);
      }

      try {
        faviconLink.href = canvas.toDataURL('image/png');
      } catch (err) {
        // Favicon likely blocked by CORS (e.g. served cross-origin without
        // the right headers) — fail silently and leave the plain favicon.
      }
    }

    function updateCount(count) {
      if (sourceImage) {
        drawBadge(count);
        return;
      }
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        sourceImage = img;
        drawBadge(count);
      };
      img.onerror = () => {};
      img.src = originalHref;
    }

    updateCount(favicon.initialCount || 0);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
          .then((r) => r.json())
          .then((cart) => updateCount(cart.item_count))
          .catch(() => {});
      });
    }
  }

  /* ---------------- Cart Notice (reactive toggle) ----------------
   * The notice markup is always rendered server-side with `hidden` set
   * correctly for the page-load cart state. Contexts that update via AJAX
   * (the cart notification popup) need it re-toggled after each cart change,
   * since Shopify's section-rendering only swaps the item list, not our
   * sibling notice element. This only re-checks "cart has items" — the
   * low-stock-only variant re-evaluates fully on the next full page load. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
        .then((r) => r.json())
        .then((cart) => {
          document.querySelectorAll('[data-mta-cart-notice]').forEach((el) => {
            el.hidden = cart.item_count === 0;
          });
        })
        .catch(() => {});
    });
  }

  /* ---------------- Inactive Tab Message ---------------- */
  const inactiveTab = config.inactiveTab;
  if (inactiveTab && inactiveTab.enabled && inactiveTab.message) {
    const originalTitle = document.title;
    document.addEventListener('visibilitychange', () => {
      document.title = document.hidden ? inactiveTab.message : originalTitle;
    });
  }
})();
